import { render, staticRenderFns } from "./levelPaymentAmount.vue?vue&type=template&id=0a602081&scoped=true&"
import script from "./levelPaymentAmount.vue?vue&type=script&lang=js&"
export * from "./levelPaymentAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a602081",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a602081')) {
      api.createRecord('0a602081', component.options)
    } else {
      api.reload('0a602081', component.options)
    }
    module.hot.accept("./levelPaymentAmount.vue?vue&type=template&id=0a602081&scoped=true&", function () {
      api.rerender('0a602081', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/roleOccupationPaymentRate/levelPaymentAmount.vue"
export default component.exports